var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2073_4212)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 9,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 15.75H18.25V13.25C18.25 12.9185 18.1183 12.6005 17.8839 12.3661C17.6495 12.1317 17.3315 12 17 12C16.6685 12 16.3505 12.1317 16.1161 12.3661C15.8817 12.6005 15.75 12.9185 15.75 13.25L15.7944 15.75H13.25C12.9185 15.75 12.6005 15.8817 12.3661 16.1161C12.1317 16.3505 12 16.6685 12 17C12 17.3315 12.1317 17.6495 12.3661 17.8839C12.6005 18.1183 12.9185 18.25 13.25 18.25L15.7944 18.2056L15.75 20.75C15.75 21.0815 15.8817 21.3995 16.1161 21.6339C16.3505 21.8683 16.6685 22 17 22C17.3315 22 17.6495 21.8683 17.8839 21.6339C18.1183 21.3995 18.25 21.0815 18.25 20.75V18.2056L20.75 18.25C21.0815 18.25 21.3995 18.1183 21.6339 17.8839C21.8683 17.6495 22 17.3315 22 17C22 16.6685 21.8683 16.3505 21.6339 16.1161C21.3995 15.8817 21.0815 15.75 20.75 15.75Z",
    fill: "#242424"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2073_4212",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2073_4212"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2073_4212",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircle);
export default __webpack_public_path__ + "static/media/icon-plus-circle.47541fabc525c1caf0c541a73de3bd4e.svg";
export { ForwardRef as ReactComponent };